import { render, staticRenderFns } from "./edit-table.vue?vue&type=template&id=5bd049ab&scoped=true&"
import script from "./edit-table.vue?vue&type=script&lang=ts&"
export * from "./edit-table.vue?vue&type=script&lang=ts&"
import style0 from "./edit-table.vue?vue&type=style&index=0&id=5bd049ab&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd049ab",
  null
  
)

export default component.exports